import { compose, withHandlers, withState, withProps } from 'recompose';

import withUpcomingGame from './queries/withUpcomingGame';

export const enhance = compose(
  withState('navigating', 'intentToNavigate', false),
  withProps(({ gameToFind }) => {
    const [product, subtype] = gameToFind?.split?.('-') || [];
    return { product, subtype };
  }),
  withUpcomingGame(),
  withHandlers({
    handleClick:
      ({ intentToNavigate, game, loading }) =>
      (event) => {
        intentToNavigate(true);
        if (!game && loading) event.preventDefault();
      },
  })
);
